import React from "react";

export default function VideoMenu({
  isAgent = false,
  onClickVirtualMeetingRoom = () => {},
}) {

  return (
    <>
      <button
        type="button"
        className={`video-call-button focus-outline-purple rounded-circle me-2 ${
          isAgent ? "agent" : ""
        }`}
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <img
          src={`/assets/plus-icon${isAgent ? "-dark" : ""}.svg`}
          alt=""
          width="14"
        />
      </button>
      <div
        className={`dropdown-menu custom-dropdown ${isAgent ? "agent" : ""}`}
      >
        <button
          type="button"
          className="dropdown-item dropdown-item--whereby"
          onClick={onClickVirtualMeetingRoom}
        >
          <img
            className="dropdown-item-icon me-2"
            src={`/assets/icon-video-plus${isAgent ? "" : "-light"}.svg`}
            alt=""
          />
          <u>Create Virtual Meeting Room</u>
        </button>
      </div>
    </>
  );
}
